import useSWR from 'swr';
import { FirmClients, FirmsDTO } from '@shared/types';
import { fetcher } from '@/utils/queries';

const useFirms = () => {
  const baseUrl = '/api/firms';

  const useGetFirms = () => {
    return useSWR<FirmsDTO[], Error>(`${baseUrl}/list`, fetcher, {
      revalidateOnFocus: false,
    });
  };

  const useGetFirmsClients = (clientId: number) => {
    return useSWR<FirmClients[], Error>(
      `${baseUrl}/firmClients/${clientId}`,
      fetcher
    );
  };

  const useGetFirmsWithClientByUserId = (userId: number) => {
    return useSWR<FirmsDTO[], Error>(
      `${baseUrl}/users/${userId}/clients`,
      fetcher
    );
  };

  const useGetFirmsWithUsers = () => {
    return useSWR<FirmsDTO[], Error>(`${baseUrl}/users`, fetcher);
  };

  return {
    useGetFirms,
    useGetFirmsClients,
    useGetFirmsWithUsers,
    useGetFirmsWithClientByUserId,
  };
};

export default useFirms;
